// Katalog kardeş sıralaması (Finar rev-2 #4b/#12b/#14, Task 6 R6-1): sürükle-bırak / ↑↓ tek
// istekte, tek transaction'da yazılır — `POST /api/v1/kpi/metrics/reorder`.

import { z } from "zod";

export const KPI_REORDER_MAX_IDS = 500;

const LowerUuid = z
  .string()
  .uuid()
  .transform((s) => s.toLowerCase());

export const KpiMetricReorderBodySchema = z
  .object({
    /** kardeşlerin üstü (kök = null) */
    parentId: LowerUuid.nullable(),
    /** üstün etkin (kalkmamış) global çocuklarının YENİ sırası — eksiksiz, tekrarsız */
    orderedIds: z.array(LowerUuid).min(1).max(KPI_REORDER_MAX_IDS),
  })
  .refine((b) => new Set(b.orderedIds).size === b.orderedIds.length, {
    path: ["orderedIds"],
    message: "Kimlikler tekrarlanamaz",
  });
export type KpiMetricReorderBody = z.infer<typeof KpiMetricReorderBodySchema>;

export const KpiMetricReorderResultSchema = z.object({
  /** gönderilen satırların yeni sırası (gönderim sırasıyla) */
  items: z.array(z.object({ id: z.string(), orderIndex: z.number().int() })),
});
export type KpiMetricReorderResult = z.infer<typeof KpiMetricReorderResultSchema>;
